import React from 'react';
import { BookingsTableData, BookingTableCellProps } from './helpers';
import Badge from '../../../ui/Badge/Badge';
import styles from './BookingsTable.module.css';
import cn from 'classnames';
import { postTypeOptions } from '../constants';

const PostTypeCell = <T extends BookingsTableData>({ value }: BookingTableCellProps<T>) => {
    const label = postTypeOptions.find((option) => option.value === value)?.label;

    return <Badge className={cn(styles.badge, styles[value])}>{label}</Badge>;
};

export default PostTypeCell;
